/// \file equipmentMakesRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const EquipmentMakesList = lazy(() => import('../views/equipment-makes/list/view'));

async function equipmentMakesDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/equipment-makes/list/loader')).default;
  return actualLoader(args);
}

export async function equipmentMakesAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/equipment-makes/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="OemEquipmentMakes"
    handle={{
      text: 'OEM Equipment Makes'
    }}
    >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <EquipmentMakesList />
        </Suspense>
      }
      loader={equipmentMakesDataLoader}
      action={equipmentMakesAction}
    />
  </Route>
);

export default routes;